import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { setTime } from 'ngx-bootstrap/timepicker/timepicker.utils';
import { DialogAbstractComponent } from '../../shared/dialogs/dialog.class';
import { AccountService } from './../../services/account.service';
import { UsersService } from './../../services/users.service';
import { GlobalValidators } from './../../utils/validators';

@Component({
  selector: 'app-confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.scss'],
})
export class ConfirmPasswordComponent extends DialogAbstractComponent implements OnInit {
  submitError: string;
  confirmPasswordErrors: string[];
  currentUser: any;
  sendingPasswordInProgress: boolean;
  confirmPasswordFG: FormGroup;
  constructor(injector: Injector, private fb: FormBuilder, private usersService: UsersService, private accountService: AccountService) {
    super(injector);
  }

  async ngOnInit() {
    this.bindConfirmPasswordForm();
  }
  bindConfirmPasswordForm() {
    this.confirmPasswordFG = this.fb.group({
      password: ['', [GlobalValidators.required, GlobalValidators.password()]],
    });
    this.confirmPasswordFG.valueChanges.subscribe((value) => {
      this.submitError = '';
    });
  }
  async confirmPassword(form) {
    if (form.invalid) {
      return;
    }
    this.sendingPasswordInProgress = true;
    this.submitError = '';
    if (this.dialogParams.saveCb) {
      let success = await this.dialogParams.saveCb(form.value.password);
      this.sendingPasswordInProgress = false;
      if (success === 'success') {
        setTimeout(() => {
          this.closeDialog();
        }, 1000);
      } else if (success === 'incorrectPassword') {
        this.submitError = 'Please Enter Correct Password to proceed';
      } else if (success === 'incorrectverification') {
        this.submitError = 'Please Enter Correct Verification code to proceed';
      } else {
        this.submitError = 'Internal Server Error, Please try again';
      }
    }
  }
  closeWindow() {
    this.closeDialog();
  }
}
